<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div>        
            <div class="atlhr-pf-wizard">
                <div class="row">
                    <div class="col-md-3 custom-sidebar py-5">
                        <h4 class="side-navbar-title mb-4">GF Dashboard</h4>
                        <div class="panel-group side-navbar" v-if="site_settings_loaded">
                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 0 }" @click.stop="open_item_selected(0)">Summary</a>

                            <!-- <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 1 }" @click.stop="open_item_selected(1)">Employee Signup</a> -->

                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 2 }" @click.stop="open_item_selected(2)">Company Migrated Fund</a>

                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 3 }" @click.stop="open_item_selected(3)">Contribution Runs</a>

                            <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 4 }" @click.stop="open_item_selected(4)">Actuarial Management</a>

                            <!-- <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 5 }" @click.stop="open_item_selected(5)">Distribution</a> -->

                            <!-- Start: Rejwan: 14-05-2025 Deregistration -->
                            <!-- <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 6 }" @click.stop="open_item_selected(6)">De-Registration from GF</a> -->
                            <div class="panel panel-default">
                                <div class="panel-heading">
                                    <h4 class="panel-title mb-0">
                                        <a :class="{ 'collapsed' : ewtabIndex != 6 && ewtabIndex != 7 }" data-toggle="collapse" href="#collapse5">De-Registration from GF</a>
                                    </h4>
                                </div>
                                <div id="collapse5" class="panel-collapse collapse" :class="{ 'show' : ewtabIndex == 6 || ewtabIndex == 7 }">
                                    <ul class="list-group">
                                        <li class="list-group-item nav-item"><a href="#" class="dropdown-item" :class="{ active : ewtabIndex == 6 }" @click.stop="open_item_selected(6)">De-Registration</a></li>
                                        <li class="list-group-item nav-item"><a href="#" class="dropdown-item" :class="{ active : ewtabIndex == 7 }" @click.stop="open_item_selected(7)">Settlements</a></li>
                                    </ul>
                                </div>
                            </div>

                            <!-- <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 4 }" @click.stop="open_item_selected(4)">Actuarial Management</a> -->
                            <!-- <a href="#" target="_self" class="nav-link" :class="{ active: ewtabIndex == 5 }" @click.stop="open_item_selected(5)">Actuarial Management</a> -->
                            <!-- End: Rejwan: 14-05-2025 Deregistration -->

                            
                        </div>
                    </div>
                    <div class="col-md-9 pr-0">
                        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
                        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
                        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>
                        <!-- <div class="row no-gutters py-2 mb-3 pl-3">
                            <div class="col-md-10 col-sm-12">
                                <h4 class="atlhr-dashboard-title mt-10">
                                    Gratuity Fund Dashboard <span class="black-title"></span>
                                    <span>
                                        <a v-bind:href="$api_url">Dashboard</a>
                                        / Gratuity Fund Dashboard
                                    </span>
                                </h4>
                            </div>
                        </div> -->
                        <div class="regulatory-filing-tab payroll-reporting-tab col-md-12" id="nav-tabContent-intro">

                            <b-tabs v-model="ewtabIndex" pills content-class="" nav-class="justify-content-left pr-2 m-2 d-none">                                
                                <template v-if="ce">
                
                                    <b-tab lazy>
                                        <!-- Start: Rejwan: 19-05-2025 GF Summary -->
                                        <!-- <div class="ibox col-md-12 border-0">
                                            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">Gratuity Fund Contribution History for {{company_name}}
                                                        <span class="title-sub-text">Get a clear picture of your GF Contribution. Use this information to better understand your workforce.
                                                        </span>
                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                            </div>
                                            <div class="ibox-content pf-overview pl-0">
                                                <div class=""> 
                                    
                                                    <div class="payslip-details-info-inner row">
                                                        <div class="col-md-4 payslip-details-info-right">
                                                            <div class="wrapper d-flex pl-0">
                                                                <div class="col-md-6">
                                                                    <div class="first pt-2">Available Forfeiture Fund</div>
                                                                </div>
                                                                <div class="col-md-6 text-right px-0">
                                                                    <div class="second">
                                                                        <div class="second">
                                                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                                                            {{ formatMoney(company_gf_history.available_ff_fund) }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-4 payslip-details-info-right">
                                                            <div class="wrapper d-flex pl-0">
                                                                <div class="col-md-6">
                                                                    <div class="first pt-2">Total Distributed Forfeiture</div>
                                                                </div>
                                                                <div class="col-md-6 text-right px-0">
                                                                    <div class="second">
                                                                        <div class="second">
                                                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                                                            {{ formatMoney(company_gf_history.company_ff_distributed_amount) }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-4 payslip-details-info-right">
                                                            <div class="wrapper d-flex pl-0">
                                                                <div class="col-md-6">
                                                                    <div class="first pt-2">Total Distributed Forfeiture Reclaim</div>
                                                                </div>
                                                                <div class="col-md-6 text-right px-0">
                                                                    <div class="second">
                                                                        <div class="second">
                                                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                                                            {{ formatMoney(company_gf_history.total_distributed_reclaim) }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-4 payslip-details-info-right">
                                                            <div class="wrapper d-flex pl-0">
                                                                <div class="col-md-6">
                                                                    <div class="first pt-2">Total Distributed Profit</div>
                                                                </div>
                                                                <div class="col-md-6 text-right px-0">
                                                                    <div class="second">
                                                                        <div class="second">
                                                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                                                            {{ formatMoney(company_gf_history.total_distributed_profit) }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-4 payslip-details-info-right">
                                                            <div class="wrapper d-flex pl-0">
                                                                <div class="col-md-6">
                                                                    <div class="first pt-2">Employer contribution till date</div>
                                                                </div>
                                                                <div class="col-md-6 text-right px-0">
                                                                    <div class="second">
                                                                        <div class="second">
                                                                            <span class="" style="font-size: 25px;">&#2547;</span>
                                                                            {{ formatMoney(company_gf_history.total_employer_contribution) }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Gratuity Fund Dashboard <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="$api_url">Dashboard</a>
                                                / Gratuity Fund Dashboard
                                            </span>
                                        </h4>

                                        <gf-dashboard></gf-dashboard>

                                        <gf-summary :company_name="company_name"></gf-summary>
                                        <!-- End: Rejwan: 19-05-2025 GF Summary -->
                                    </b-tab>
                                    <b-tab lazy>                                       
                                        <div class="ibox col-md-12 border-0">
                                            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">Employee Signup
                                                        <span class="title-sub-text">Employee gratuity fund registration and process gf applications.</span>
                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                            </div>
                                            <div class="ibox-content pf-overview pl-0">
                                                <div class="">
                                                    <gfsignup :pageurl="this.$api_url" :flg="c_flg" v-on:childToParent="getAccountEmployees"></gfsignup>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab lazy>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Gratuity Fund Dashboard <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="$api_url">Dashboard</a>
                                                / Gratuity Fund Dashboard / Company Migrated Fund
                                            </span>
                                        </h4>
                                            <!-- <h4 class="mb-2 pb-2 border-bottom pb-2 mt-5">Migrated Gratuity Fund Contributions</h4>
                                        <p style="font-size: 15px; padding-bottom: 30px;">Migrated Gratuity Fund Contributions.</p> -->
                                        <template active v-slot:title>Migrated Gratuity Fund Contributions</template>                
                                        <div class="clearfix">
                                            <div class="">                            
                                                <gf-migrated-fund-form :pageurl="this.$api_url" :flg="c_flg"  v-on:childToParent="getAccountEmployees"></gf-migrated-fund-form>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab lazy>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Gratuity Fund Dashboard <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="$api_url">Dashboard</a>
                                                / Gratuity Fund Dashboard / Contribution Runs
                                            </span>
                                        </h4>
                                                      
                                        <div class="clearfix">
                                            <div class="">                            
                                                <gf-run :pageurl="this.$api_url" :flg="c_flg"></gf-run>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab lazy>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Gratuity Fund Dashboard <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="$api_url">Dashboard</a>
                                                / Gratuity Fund Dashboard / Actuarial Management
                                            </span>
                                        </h4>
                                            <!-- <h4 class="mb-2 pb-2 border-bottom pb-2 mt-5">Actuarial Management</h4> -->
                                        <!-- <p style="font-size: 15px; padding-bottom: 30px;">Deregister employees from gratuity fund. Process deregistration applications.</p> -->
                                        <template active v-slot:title>De-Registration from GF</template>                
                                        <div class="clearfix">
                                            <div class="ibox p-3">                            
                                                <gf-acturial-list :pageurl="this.$api_url" :flg="c_flg"  v-on:childToParent="getAccountEmployees"></gf-acturial-list>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab lazy>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Gratuity Fund Dashboard <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="$api_url">Dashboard</a>
                                                / Gratuity Fund Dashboard / Distribution
                                            </span>
                                        </h4>
                                        <!-- <h4 class="mb-2 pb-2 border-bottom pb-2 mt-5">Distribution</h4> -->
                                        <p style="font-size: 15px; padding-bottom: 30px;">Distribute Company profit,forfeiture fund. Process forfeiture reclaims.</p>
                                    
                                        <template active v-slot:title>Distribution</template>                
                                        <div class="clearfix">
                                            <div class="">
                                                <gf-distribution :pageurl="this.$api_url" :flg="c_flg"></gf-distribution>
                                            </div>
                                        </div>
                                    </b-tab>

                                    <!-- Start: Rejwan: 14-05-2025 Deregistration -->
                                    <b-tab lazy>
                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Gratuity Fund Dashboard <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="$api_url">Dashboard</a>
                                                / Gratuity Fund Dashboard / De-Registration from GF / De-Registration
                                            </span>
                                        </h4>
                                        <div class="ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">De-Registration from Gratuity Fund
                                                        <span class="title-sub-text">Deregister employees from gratuity fund. Process deregistration applications.
                                                        </span>
                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                            </div>
                                            <div class="clearfix">
                                                <div class="">
                                                    <gf-de-registration :pageurl="this.$api_url" :flg="c_flg"
                                                    v-on:childToParent="getAccountEmployees"></gf-de-registration>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>

                                    <b-tab lazy>

                                        <h4 class="atlhr-dashboard-title mt-10 mb-4">
                                            Gratuity Fund Dashboard <span class="black-title"></span>
                                            <span>
                                                <a v-bind:href="$api_url">Dashboard</a>
                                                / Gratuity Fund Dashboard / De-Registration from GF / Settlements
                                            </span>
                                        </h4>

                                        <div class="ibox col-md-12 border-0">
                                            <div
                                                class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
                                                <h4 class="clearfix">
                                                    <span class="float-left">Settlements for Former Members of GF
                                                        <span class="title-sub-text">Settlement processing for Former Members of Gratuity Fund, including starting from creating settlement applications, going through approvals, and disbursing to bank.
                                                        </span>
                                                    </span>
                                                    <span class="float-right">
                                                    </span>
                                                </h4>
                                            </div>
                                            <div class="clearfix">
                                                <div class="">
                                                    <gf-settlement-dashboard :pageurl="this.$api_url" :flg="c_flg"
                                                    v-on:childToParent="getAccountEmployees"></gf-settlement-dashboard>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>

                                    <!-- <b-tab lazy>
                                            <h4 class="mb-2 pb-2 border-bottom pb-2 mt-5">De-Registration from Gratuity Fund</h4>
                                        <p style="font-size: 15px; padding-bottom: 30px;">Deregister employees from gratuity fund. Process deregistration applications.</p>
                                        <template active v-slot:title>De-Registration from GF</template>                
                                        <div class="clearfix">
                                            <div class="">                            
                                                <gf-de-registration :pageurl="this.$api_url" :flg="c_flg"  v-on:childToParent="getAccountEmployees"></gf-de-registration>
                                            </div>
                                        </div>
                                    </b-tab> -->
                                    <!-- End: Rejwan: 14-05-2025 Deregistration -->

                                    
                                </template>                                
                            </b-tabs>
                        </div>
                    </div>
                </div>



                <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
                    <keep-alive>
                        <SearchEmployees :pageurl="this.$api_url" ></SearchEmployees>
                    </keep-alive>
                </b-modal>
            </div>
        </div>
    </b-overlay>
</template>
<script>        
    export default{
        mounted() {
            this.setTabIndex();
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);    
            
        },
        props: ['readonly','pageurl'],
        components: {
            
        },
      
            data(){            
            
            return {
                showoverlay : false,
                cu:window.location.href,
                ce : false,
                company_name:'',
                avatarsrc : null,
                employee_id : 0,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                pageUrl : this.$api_url,
                pgeUrl : this.$api_url,
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                company_gf_history:[{available_ff_fund:0,company_ff_fund:0}],

                c_flg: 0, // This variable is for reloading public info
                site_setting: {
                    // gratuity_fund_investment_feature: 0,
                },
                site_settings_loaded: false,

            }
        },
        methods:{
            open_item_selected: function (item) {
                this.ewtabIndex = item;
            },
            showContent: function()
            {
                this.showoverlay = false;
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            getEmployeeData: function(){
                if(!this.checkNet()) return false;
                
                this.c_flg += 1;
                //alert('hi');
                /*axios.get('/employee/publicinfo')
                    .then(function (response) {
                        
                        this.public_info = response.data;
                        this.company_id = this.public_info.company_id;
                        this.employee_id = this.public_info.employee_id;
                        
                        this.avatarsrc ='/public/images/employee/'+ this.company_id + '/' + this.public_info.pic;

                    }.bind(this));*/
            }, 
            formatMoney: function(amount){
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },                       
            handleHover(hovered) {
                
                this.isHovered = hovered
            },
            getAccountEmployees (value) 
            {
                this.employee_id = value.employee_id;
                if(this.employee_id > 0)
                {
                    this.getEmployeeData();
                }                   

            },
            getContractForm (value) 
            {
                this.public_info.contract_expire = value.contract_expire;
            },
            getCompanyGFData: function(){
            let currentObj = this;
              axios.get(this.$api_url+'/gf/get_company_gf_data', {
                    params: {
    
                    }
                    })
              .then(function (response) {
                 this.company_gf_history = response.data;
                 this.company_gf_history.available_ff_fund = this.company_gf_history.company_ff_fund - this.company_gf_history.company_ff_distributed_amount - this.company_gf_history.total_distributed_reclaim;
                 this.site_settings_loaded = true; 
              }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
         
            },
            getGFReportHeaderInfo: function(){
              axios.get(this.$api_url+'/gf/gfreport/header') 
              .then(function (response) {
                 this.company_name = response.data.company_name;
                 
                 
              }.bind(this));
         
            },
            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getid')
                    .then(function (response) {

                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }
                        
                        this.employee_id = response.data;
                        
                            let uri = window.location.href.split('?');
                            if (uri.length == 2)
                            {
                                let vars = uri[1].split('&');
                                let getVars = {};
                                let tmp = '';
                                vars.forEach(function(v){
                                    tmp = v.split('=');
                                    if(tmp.length == 2)
                                        getVars[tmp[0]] = tmp[1];
                                });
                                //console.log(getVars['#']);
                                if(getVars['#'])
                                    this.ewtabIndex = parseInt(getVars['#']);
                                
                            }                       
                                            

                    }.bind(this));                

            },
            // loadGfSiteOptions() {
            //     axios.get(this.$api_url + '/load-site-options').then(response => {
            //         response.data.forEach(o => {
            //             if (['gratuity_fund_investment_feature'].includes(o.opt_key)) {
            //                 this.site_setting[o.opt_key] = o.opt_value;
            //             }
            //         });
            //         this.site_settings_loaded = true; 
            //     });
            // },
        },
        created: function(){
            //
            this.getAcl();
            this.getGFReportHeaderInfo();
            this.getCompanyGFData();
            // this.loadGfSiteOptions();
            //this.getEmployeeData();
            //this.setTabIndex();
        }

    }

</script>